import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-数据管理_钻具组合",
  "use": "icon-数据管理_钻具组合-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-数据管理_钻具组合\">\n<g>\n\t<g>\n\t\t<path d=\"M8.8,0.7v5.4H7.2V0.7H8.8 M9.5,0H6.5v6.9h3.1V0L9.5,0z\" />\n\t</g>\n\t<g>\n\t\t<path d=\"M13.6,6.9v2.9H2.4V6.9H13.6 M14.3,6.1H1.7v4.4h12.7V6.1L14.3,6.1z\" />\n\t</g>\n\t<g>\n\t\t<path d=\"M10.7,10.5l-1.5,4.7H6.9l-1.5-4.7H10.7 M11.7,9.8H4.3l2,6.2h3.4L11.7,9.8L11.7,9.8z\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol